import Showcase from "./Showcase";
import ShowcaseArticle from "./Article";
import ShowcaseShop from "./ShowcaseShop";
import ShowcaseShopItem from "./ShowcaseShopItem";

export default Showcase;
Showcase.Article = ShowcaseArticle;
Showcase.Shop = ShowcaseShop;
Showcase.Shop.Item = ShowcaseShopItem;
